import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";
import { forwardRef } from "react";
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M17.751 14.415 11.623 3.738c-.717-1.251-2.528-1.251-3.246 0L2.249 14.415c-.712 1.24.188 2.785 1.624 2.785h12.255c1.435 0 2.335-1.544 1.623-2.785ZM10.7 7.2a.7.7 0 0 0-1.4 0v4.2a.7.7 0 1 0 1.4 0V7.2Zm-.607 6.006-.094-.006-.087.005A.799.799 0 0 0 10 14.8a.8.8 0 0 0 .093-1.594Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponent);
export default ForwardRef;
//# sourceMappingURL=WarningFilledIcon20.js.map